import { supabase } from '../../../lib/supabaseClient';
import type { ProcessBlueprintLog } from '../../../types/processBlueprintLog';

export async function listGovernanceLogs(blueprintId: string, organizationId: string) {
  const { data, error } = await supabase
    .from('process_blueprint_logs')
    .select('*')
    .eq('blueprint_id', blueprintId)
    .eq('organization_id', organizationId)
    .order('created_at', { ascending: false });
  if (error) throw error;
  return (data ?? []) as ProcessBlueprintLog[];
}

export async function logGovernanceAction(payload: Omit<ProcessBlueprintLog, 'created_at' | 'id'>) {
  const { error } = await supabase.from('process_blueprint_logs').insert({ ...payload });
  if (error) throw error;
}
